const $ = jQuery;

export default class Places {
    constructor(options = null) {
        this.Places = null;
        this.autocomplete = null;
        this.$latitudeInput = document.getElementById("latitude");
        this.$longitudeInput = document.getElementById("longitude");
        // this.__googleApi();
        this.placesOject = null;
    }

    async __loadGoogleMapsLibrary() {
        const { Places } = await google.maps.importLibrary("places");
        this.Places = Places;
    }

    async __googleApi() {
        ((g) => {
            var h,
                a,
                k,
                p = " The Google Maps JavaScript API",
                c = "google",
                l = "importLibrary",
                q = "__ib__",
                m = document,
                b = window;
            b = b[c] || (b[c] = {});
            var d = b.maps || (b.maps = {}),
                r = new Set(),
                e = new URLSearchParams(),
                u = () =>
                    h ||
                    (h = new Promise(async (f, n) => {
                        await (a = m.createElement("script"));
                        e.set("libraries", [...r] + "");
                        for (k in g)
                            e.set(
                                k.replace(/[A-Z]/g, (t) => "_" + t[0].toLowerCase()),
                                g[k]
                            );
                        e.set("callback", c + ".maps." + q);
                        a.src = `https://maps.${c}apis.com/maps/api/js?libraries=places&` + e;
                        d[q] = f;
                        a.onerror = () => (h = n(Error(p + " could not load.")));
                        a.nonce = m.querySelector("script[nonce]")?.nonce || "";
                        m.head.append(a);
                    }));
            d[l] ? console.warn(p + " only loads once. Ignoring:", g) : (d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)));
        })({
            key: site_data.google_api_key,
            v: "weekly",
            // Use the 'v' parameter to indicate the version to use (weekly, beta, alpha, etc.).
            // Add other bootstrap parameters as needed, using camel case.
        });
    }

    async init() {
        this.__googleApi();
        await this.__loadGoogleMapsLibrary();
        this.__initAutocomplete();
        this.__initFormSubmission();
    }

    __initFormSubmission() {
        if (document.querySelector("#geolocateForm")) {
            const form = document.getElementById("geolocateForm");
            form.addEventListener("submit", (event) => {
                event.preventDefault(); // Prevent default form submission
                // this.__submitGeolocation(); // Call geolocation submission
                const lat = this.$latitudeInput.value;
                const lng = this.$longitudeInput.value;
                window.location.href = `/find-a-tutor?lat=${encodeURIComponent(lat)}&lng=${encodeURIComponent(lng)}`;
            });
        }
    }

    __initAutocomplete() {
        this.autocomplete = new google.maps.places.Autocomplete(document.getElementById("findCoordinates"), { types: ["geocode"] });
        this.autocomplete.setFields(["address_component", "geometry"]);
        this.autocomplete.addListener("place_changed", this.__fillInAddress.bind(this));
    }

    __fillInAddress() {
        this.placesOject = this.autocomplete.getPlace();
        this.$latitudeInput.value = this.placesOject.geometry.location.lat();
        this.$longitudeInput.value = this.placesOject.geometry.location.lng();
    }
}
